/**
 * This function relates to task POR-3537. It removes all functions in Portal if they are not in the allowed cookie list.
 * Javascript cannot detect HTTPOnly cookies, so this will only work for some cookies
 */
export function removeAllNonPortalCookies() {
	const cookieAllowList = ['XSRF-TOKEN', 'caliber_session', 'EXPORTSAUTH'];
	const cookies = document.cookie.split('; ').map(c => c.split('='));

	cookies.forEach((cookieArray) => {
		const name = cookieArray[0];
		const value = cookieArray[1];
		if(cookieAllowList.includes(name)){
			return;
		}

		document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=.groupcaliber.com;";
		console.warn(`Removed cookie ${name}`);
	});
}
